import React, { FC, memo, useEffect, useState } from 'react';
import Breadcrumbs from '@components/Breadcrumbs';
import routes from '../../constants/routes';
import useCustomRouter from '@hooks/useCustomRouter';
import useTranslations from '@hooks/useTranslations';
import { IBreadcrumbItem } from 'src/redux/commonDucks/ui.duck.interface';
import { SC } from '../../styles/theme';

export const MyAccountBreadcrumbsTemplate: FC<SC> = memo(({ className }: SC) => {
    const { t } = useTranslations();
    const router = useCustomRouter();

    const defaultBreadcrumbsItems = [
        { idx: 0, text: t('myaccount.nav.home'), url: routes.ROOT },
        { idx: 3, text: t('myaccount.nav.myAccount'), url: routes.MY_ACCOUNT },
    ];

    const [items, setItems] = useState<IBreadcrumbItem[]>(defaultBreadcrumbsItems);

    useEffect(() => {
        const { MY_SAVES, MY_ORDERS } = routes;
        const possibleRoutes = {
            [MY_SAVES]: { idx: 2, text: t('myaccount.nav.mySaves'), url: MY_SAVES },
            [MY_ORDERS]: { idx: 2, text: t('myaccount.nav.myOrders'), url: MY_ORDERS },
        };

        const tempItems = [...defaultBreadcrumbsItems];
        if (possibleRoutes[router.route]) {
            tempItems.push(possibleRoutes[router.route]);
        }

        setItems(tempItems);
    }, [router.route]);

    return (
        <div className={className}>
            <Breadcrumbs items={items} />
        </div>
    );
});
MyAccountBreadcrumbsTemplate.displayName = 'MyAccountBreadcrumbsTemplate';
